import {SvgIcon, SvgIconProps} from "@mui/material";

export const HexagonShapeIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            d="M7 3h10l5 9-5 9H7L2 12 7 3z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
